import { whenHasValue } from 'src/shared/NullUtil';

export abstract class VimeoParser {

    private readonly nodeName: string;
    private readonly videoAttributeSourceName: string;

    protected constructor(nodeName: string, videoAttributeSourceName: string) {
        this.nodeName = nodeName;
        this.videoAttributeSourceName = videoAttributeSourceName;
    }

    /**
     * Extracts the video id from the given url
     * @param url       The url to extract the video id from
     * @return          The video id if it can be extracted, otherwise `null`
     */
    public abstract extract(url: string): string | null;

    /**
     * Get the value of the video source attribute from the given node
     * @param element     The node from which to extract the video source attribute
     * @return         The value of the video source attribute if it exists, otherwise `null`
     */
    public getAttributeValue(element: Element): string | null {
        return element.getAttribute(this.videoAttributeSourceName);
    }

    /**
     * Get the nodes that match the parser's node name
     * @param target    The document to search for nodes
     * @return          A tuple containing the parser and the nodes
     */
    public getNodes(target: Document): [VimeoParser, Element[]] {
        return [this, Array.from(target.querySelectorAll(this.nodeName))];
    }

    /**
     * Extracts the video id from the given regex matches
     * @param parsedUrl The regex matches to extract the video id from
     * @return          The video id if it can be extracted, otherwise `null`
     */
    protected parseVideoId(parsedUrl: (string | undefined)[]): string | null {
        // parsed url splits into 3: validation part as 'https://vimeo-domain',
        // potential videoId and anything after videoId.
        // Check what is in the third one as there should not be anything else then arguments
        if (parsedUrl[2] !== undefined && parsedUrl[2][0] !== '?') {
            return null;
        }
        return whenHasValue(parsedUrl[1], (videoId) => {
            return videoId;
        });
    }

}
